import { EDraftStatus, EStatus, EStringOp } from '@src/emp-3.0/types';

export const isDeployed = (data): boolean => {
  return data?.status === EStatus.DEPLOYED;
};

export const isUndeployed = (data): boolean => {
  return data?.status === EStatus.UNDEPLOYED;
};

export const canBeDeleted = (data): boolean => {
  return !!data?.can_deleted;
};

export const isDraftVersion = (data): boolean => {
  return data?.is_draft === EDraftStatus.isDraft;
};

export const isMultiVersion = (data): boolean => {
  return data?.is_multi_version;
};

export const isBlockAll = (data): boolean => {
  return data?.block_rules?.length === 0;
};

export const isBlockByRules = (data): boolean => {
  return data?.block_rules?.length !== 0;
};

export const isStoragePredefinedMappedEvent = (data): boolean => {
  return data?.storage_predefined_mapped_event;
};

export const isEmptyOrNotEmptyOp = (data): boolean => {
  return data === EStringOp.IS_EMPTY || data === EStringOp.IS_NOT_EMPTY;
};

export const isTraceId = (data) => {
  return data?.dimension_identifier === 'trace_id';
};

export function isUndefined(value: any): value is undefined {
  return typeof value === 'undefined';
}

export function isNull(value: any): boolean {
  return value === null;
}

export const hasRelatedMetrics = (data): boolean => {
  return (data?.related_metrics ?? []).length > 0;
};

export const hasRelatedFlows = (data): boolean => {
  return (data?.related_flows ?? []).length > 0;
};
